// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/core/v1/block.proto (package thru.core.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Pubkey, Signature } from "../../common/v1/primitives_pb";
import { file_thru_common_v1_primitives } from "../../common/v1/primitives_pb";
import type { ConsensusStatus } from "../../common/v1/consensus_pb";
import { file_thru_common_v1_consensus } from "../../common/v1/consensus_pb";
import type { BlockHash } from "./types_pb";
import { file_thru_core_v1_types } from "./types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/core/v1/block.proto.
 */
export const file_thru_core_v1_block: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_api_field_behavior, file_google_protobuf_timestamp, file_thru_common_v1_primitives, file_thru_common_v1_consensus, file_thru_core_v1_types]);

/**
 * BlockHeader describes metadata about a block.
 *
 * @generated from message thru.core.v1.BlockHeader
 */
export type BlockHeader = Message<"thru.core.v1.BlockHeader"> & {
  /**
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * @generated from field: thru.core.v1.BlockHash block_hash = 2;
   */
  blockHash?: BlockHash | undefined;

  /**
   * @generated from field: thru.common.v1.Signature header_signature = 3;
   */
  headerSignature?: Signature | undefined;

  /**
   * @generated from field: uint32 version = 4;
   */
  version: number;

  /**
   * @generated from field: thru.common.v1.Pubkey producer = 5;
   */
  producer?: Pubkey | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expiry_timestamp = 6;
   */
  expiryTimestamp?: Timestamp | undefined;

  /**
   * @generated from field: uint64 start_slot = 7;
   */
  startSlot: bigint;

  /**
   * @generated from field: uint32 expiry_after = 8;
   */
  expiryAfter: number;

  /**
   * @generated from field: uint32 max_block_size = 9;
   */
  maxBlockSize: number;

  /**
   * @generated from field: uint64 max_compute_units = 10;
   */
  maxComputeUnits: bigint;

  /**
   * @generated from field: uint32 max_state_units = 11;
   */
  maxStateUnits: number;

  /**
   * @generated from field: uint64 bond_amount_lock_up = 12;
   */
  bondAmountLockUp: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp block_time = 13;
   */
  blockTime?: Timestamp | undefined;

  /**
   * @generated from field: uint64 weight_slot = 14;
   */
  weightSlot: bigint;

  /**
   * @generated from field: uint32 chain_id = 15;
   */
  chainId: number;
};

/**
 * Describes the message thru.core.v1.BlockHeader.
 * Use `create(BlockHeaderSchema)` to create a new message.
 */
export const BlockHeaderSchema: GenMessage<BlockHeader> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_block, 0);

/**
 * BlockFooter captures execution result metadata for a block.
 *
 * @generated from message thru.core.v1.BlockFooter
 */
export type BlockFooter = Message<"thru.core.v1.BlockFooter"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: thru.core.v1.ExecutionStatus status = 2;
   */
  status: ExecutionStatus;

  /**
   * @generated from field: uint64 consumed_compute_units = 3;
   */
  consumedComputeUnits: bigint;

  /**
   * @generated from field: uint32 consumed_state_units = 4;
   */
  consumedStateUnits: number;

  /**
   * @generated from field: uint64 attestor_payment = 5;
   */
  attestorPayment: bigint;
};

/**
 * Describes the message thru.core.v1.BlockFooter.
 * Use `create(BlockFooterSchema)` to create a new message.
 */
export const BlockFooterSchema: GenMessage<BlockFooter> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_block, 1);

/**
 * Block represents a fully decoded block resource.
 *
 * @generated from message thru.core.v1.Block
 */
export type Block = Message<"thru.core.v1.Block"> & {
  /**
   * @generated from field: thru.core.v1.BlockHeader header = 1;
   */
  header?: BlockHeader | undefined;

  /**
   * @generated from field: optional thru.core.v1.BlockFooter footer = 2;
   */
  footer?: BlockFooter | undefined;

  /**
   * @generated from field: optional bytes body = 3;
   */
  body?: Uint8Array | undefined;

  /**
   * @generated from field: optional thru.common.v1.ConsensusStatus consensus_status = 4;
   */
  consensusStatus?: ConsensusStatus | undefined;
};

/**
 * Describes the message thru.core.v1.Block.
 * Use `create(BlockSchema)` to create a new message.
 */
export const BlockSchema: GenMessage<Block> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_block, 2);

/**
 * RawBlock captures raw block bytes for direct access.
 *
 * @generated from message thru.core.v1.RawBlock
 */
export type RawBlock = Message<"thru.core.v1.RawBlock"> & {
  /**
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * @generated from field: bytes raw_block = 2;
   */
  rawBlock: Uint8Array;
};

/**
 * Describes the message thru.core.v1.RawBlock.
 * Use `create(RawBlockSchema)` to create a new message.
 */
export const RawBlockSchema: GenMessage<RawBlock> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_block, 3);

/**
 * BlockView controls how much of a block resource is returned.
 *
 * @generated from enum thru.core.v1.BlockView
 */
export enum BlockView {
  /**
   * @generated from enum value: BLOCK_VIEW_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BLOCK_VIEW_HEADER_ONLY = 1;
   */
  HEADER_ONLY = 1,

  /**
   * @generated from enum value: BLOCK_VIEW_HEADER_AND_FOOTER = 2;
   */
  HEADER_AND_FOOTER = 2,

  /**
   * @generated from enum value: BLOCK_VIEW_BODY_ONLY = 3;
   */
  BODY_ONLY = 3,

  /**
   * @generated from enum value: BLOCK_VIEW_FULL = 4;
   */
  FULL = 4,
}

/**
 * Describes the enum thru.core.v1.BlockView.
 */
export const BlockViewSchema: GenEnum<BlockView> = /*@__PURE__*/
  enumDesc(file_thru_core_v1_block, 0);

/**
 * ExecutionStatus enumerates block execution results.
 *
 * @generated from enum thru.core.v1.ExecutionStatus
 */
export enum ExecutionStatus {
  /**
   * @generated from enum value: EXECUTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXECUTION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: EXECUTION_STATUS_EXECUTED = 2;
   */
  EXECUTED = 2,

  /**
   * @generated from enum value: EXECUTION_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum thru.core.v1.ExecutionStatus.
 */
export const ExecutionStatusSchema: GenEnum<ExecutionStatus> = /*@__PURE__*/
  enumDesc(file_thru_core_v1_block, 1);

